import Carousel from "components/Carousel";
import Content from "components/Content";
import Label from "components/Label";
import Media from "components/Media";
import ScrollView from "components/ScrollView";
import React, { FC } from "react";
import { useTheme } from "theme/ThemeCreator";
import ProviderReview from "./components/ProviderReview";
import { reviews } from "./consants";
import styles from "./styles.module.scss";

const HearFromOurProviders: FC = () => {
  const { colors } = useTheme();

  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <Label variant="h2-centered" color="primary">
        Hear from our service providers
      </Label>
      <Media at={["desktop", "tablet"]}>
        <Carousel gradient={false} className={styles.reviews}>
          {reviews.map((review) => (
            <ProviderReview key={review.content} {...review} />
          ))}
        </Carousel>
      </Media>
      <Media className={styles.media} at={["mobile"]}>
        <ScrollView
          colors={{ indicatorColor: colors.supplementalVariant1 }}
          className={styles.reviews}
          itemWidth={100}
        >
          {reviews.map((review) => (
            <ProviderReview key={review.content} {...review} />
          ))}
        </ScrollView>
      </Media>
    </Content>
  );
};

export default HearFromOurProviders;
